/**
 * Module dependencies.
 */

import { apiEndpoints } from 'app/core/config/api-endpoints';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { useQuery } from '@tanstack/react-query';

/**
 * Export `useGetLogVersions`.
 */

export function useGetLogVersions(fromDate?: string, toDate?: string) {
  const client = useRequestProvider();

  return useQuery({
    queryKey: ['log-versions', fromDate, toDate],
    queryFn: async () => {
      const params: Record<string, string> = {};
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

      const url = resolveAppUrl(apiEndpoints.logsVersions);
      const response = await client.get(url, { params });

      return (response.data?.data ?? response.data ?? []) as string[];
    }
  });
}
